/* Archive Art Co. — global theme JS */
(function () {
  function initReveals(scope) {
    var els = (scope || document).querySelectorAll('.reveal:not(.in)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initReveals(); });
  } else {
    initReveals();
  }

  /* Re-run inside the Shopify theme editor when sections reload */
  document.addEventListener('shopify:section:load', function (e) { initReveals(e.target); });
})();

/* Money formatting shared by product form scripts */
window.archiveFormatMoney = function (cents) {
  var format = window.themeMoneyFormat || '${{amount}}';
  var amount = (cents / 100).toFixed(2);
  return format
    .replace(/\{\{\s*amount\s*\}\}/g, amount)
    .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(cents / 100))
    .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','));
};
